// Firebase configuration for different environments
export interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId?: string;
}

// Production environment configuration
export const productionConfig: FirebaseConfig = {
  apiKey: "AIzaSyABZFHqG8o0oExSUja4JfBPs4Mg33Jy7SM",
  authDomain: "bbtech-b67fa.firebaseapp.com",
  projectId: "bbtech-b67fa",
  storageBucket: "bbtech-b67fa.firebasestorage.app",
  messagingSenderId: "1053963008505",
  appId: "1:1053963008505:web:b6633cdd83d8e8f563e528",
  measurementId: "G-TBYPMNRMLF"
};

// Development environment configuration
export const developmentConfig: FirebaseConfig = {
  apiKey: "AIzaSyDicnb3F3UtPp55McoQfnwoN0oxcB1JxTY",
  authDomain: "bbtech-dev.firebaseapp.com",
  projectId: "bbtech-dev",
  storageBucket: "bbtech-dev.firebasestorage.app",
  messagingSenderId: "119574184120",
  appId: "1:119574184120:web:a7723dcece89cf46c1344d"
};

// Get current environment based on hostname or environment variable
export const getCurrentEnvironment = (): 'development' | 'production' => {
  // Check if we're running on development hosting URL
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    const href = window.location.href;
    
    console.log('Environment detection debug:', {
      hostname,
      href,
      mode: import.meta.env.MODE,
      fullUrl: window.location.href
    });
    
    // More specific detection for development environment
    if (hostname === 'bbtech-dev-admin.web.app' || 
        hostname.includes('bbtech-dev-admin') || 
        hostname.includes('localhost') || 
        href.includes('bbtech-dev-admin')) {
      console.log('✅ Detected development environment');
      return 'development';
    }
    
    console.log('❌ Not development environment, using production');
  }
  
  // Fallback to Vite environment mode
  const env = import.meta.env.MODE === 'development' ? 'development' : 'production';
  console.log('Using fallback environment:', env);
  return env;
};

// Get Firebase configuration based on current environment
export const getFirebaseConfig = (): FirebaseConfig => {
  const environment = getCurrentEnvironment();
  console.log(`Using Firebase environment: ${environment}`);
  return environment === 'development' ? developmentConfig : productionConfig;
};
